import { Box, Typography } from "@mui/material";
import stockBall from '../icons/stock_ball.jpg';
import { getGoogleDriveMediaUrl } from '../utils/getGoogleDriveMediaUrl';
import SmartImage from '../utils/SmartImage';

export default function MinorInfoBox({ 
    title = "Título da notícia", 
    subtitle = "Descrição da notícia aparecerá aqui...", 
    mediaUrl = stockBall,
    driveFileId,
    thumbnailUrl,
    onClick,
    isClickable = false,
    marginBottom = 2,
    disableResponsiveness = false,
}) {
    const normalizedUrl = getGoogleDriveMediaUrl(mediaUrl, driveFileId, undefined, thumbnailUrl);
    const finalUrl = normalizedUrl || stockBall;
    return (
        <Box 
            sx={{
                width: disableResponsiveness ? 336 : { xs: 236, md: 336},
                display: "flex",    
                flexDirection: disableResponsiveness ? "row" : { xs: "column", md: "row" }, 
                marginBottom: marginBottom,
                alignItems: disableResponsiveness ? "flex-start" : { xs: "center", md: "flex-start" },
                gap: { xs: 1, sm: 1, md: 1 },
                flexShrink: 0,
                overflow: 'hidden',
                transition: 'all 0.2s ease-in-out',
                '&:hover': isClickable ? {
                    '& .title-text': {
                        color: 'steelBlue',
                    },
                    '& .subtitle-text': {
                        color: 'steelBlue',
                    }
                } : {}
            }}
        >
            <Box 
                onClick={isClickable ? onClick : undefined}
                sx={{
                    width: disableResponsiveness ? 120 : { xs: 230, md: 120 }, 
                    height: 120, 
                    borderRadius:"0.75vw", 
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    overflow: 'hidden',
                    background: '#f5f5f5',
                    cursor: isClickable ? 'pointer' : 'default',
                    
                }}
            >
                {finalUrl && (
                    <SmartImage 
                        src={finalUrl} 
                        alt={title}
                        driveFileId={driveFileId}
                        fallbackSrc={stockBall}
                        style={{
                            width: '100%',
                            height: '100%',
                            objectFit: 'cover',
                            borderRadius: '0.75vw',
                            display: 'block'
                        }}
                    />
                )}
            </Box>
            <Box sx={{ flex: 1, minWidth: 0, padding: 1 }}>
                <Typography 
                    className="title-text"
                    onClick={isClickable ? onClick : undefined}
                    sx={{
                        fontFamily: "Atlan",
                        fontWeight: "bold",
                        overflow: "hidden", 
                        textOverflow: "ellipsis",
                        display: '-webkit-box',
                        WebkitBoxOrient: 'vertical',
                        WebkitLineClamp: 2,
                        fontSize: 18,
                        lineHeight: { xs: 1.2, sm: 1.25, md: 1.2 },
                        marginX: { xs: 0, md: 1 },
                        marginBottom: 0.5,
                        transition: 'color 0.2s ease-in-out',
                        cursor: isClickable ? 'pointer' : 'default'
                    }}
                >
                    {title}
                </Typography>
                <Typography 
                    className="subtitle-text"
                    onClick={isClickable ? onClick : undefined}
                    sx={{
                        fontFamily: "Atlan",
                        overflow: 'hidden',
                        textOverflow: "ellipsis",
                        display: '-webkit-box', 
                        WebkitBoxOrient: 'vertical',
                        WebkitLineClamp: { xs: 5, sm: 4, md: 3 },
                        fontSize: 14,
                        color: '#666',
                        marginX: { xs: 0, md: 1 },
                        transition: 'color 0.2s ease-in-out',
                        cursor: isClickable ? 'pointer' : 'default'
                    }}
                >
                    {subtitle}
                </Typography>
            </Box>
        </Box>
    );
}